module.exports = __webpack_public_path__ + "img/prjpro.c20ed6b2.svg";